import { Status } from 'feature/statuses/types'

import { AppealStatus } from '../type'

type TStatusArray = {
  [key in AppealStatus]: Status
}

// определение значения для цвета <Chip> по статусу заявки

export const appealStatus = (status: AppealStatus): Status => {
  const appeals: TStatusArray = {
    PREPROCESSING: 'progress',
    DEALER_SELECTED: 'progress',
    VISIT_OFFER: 'progress',
    VISIT_PAID: 'progress',
    OFFER: 'progress',
    OFFER_PAID: 'progress',
    PROCESSING: 'progress',
    GRADE_WAITING: 'progress',
    AWAITING_PAYMENT: 'progress',
    WAITING_DEALER: 'progress',
    FIXING: 'progress',
    COMPLETED: 'done',
    CANCELED: 'canceled',
    UNKNOWN: 'canceled',
    SCHEDULED: 'progress',
  }
  return appeals[status]
}
